import { API_TYPE } from "../../../utils/config";

export const EURAIL_PASS_SEARCH = API_TYPE("EURAIL_PASS_SEARCH");
export const EURAIL_PASS_COUNTRIES = API_TYPE("EURAIL_PASS_COUNTRIES");
export const GET_EURAIL_PASS_LIST = API_TYPE("GET_EURAIL_PASS_LIST");
export const EURAIL_PASS_PRE_BOOK = API_TYPE("EURAIL_PASS_PRE_BOOK");
export const EURAIL_PASS_CHECKOUT = API_TYPE("EURAIL_PASS_CHECKOUT");
